(() => {
  function initialize(product) {
    const bar=product.querySelector('[data-cc-sticky-bar]');const main=product.querySelector('[data-cc-main-add]');
    if(!bar || !main || product.dataset.stickyReady) return;
    product.dataset.stickyReady='true';
    let passed=false;
    const sync=()=>bar.hidden=!passed || !!document.querySelector('cart-drawer.active,dialog[open]');
    const observer=new IntersectionObserver(entries=>{passed=entries[0].boundingClientRect.bottom<0;sync();},{threshold:0});observer.observe(main);
    document.addEventListener('cc:cart-state',sync);
    const drawer=document.querySelector('cart-drawer');if(drawer)new MutationObserver(sync).observe(drawer,{attributes:true,attributeFilter:['class']});
    document.addEventListener('toggle',sync,true);
  }
  document.querySelectorAll('cc-case-product').forEach(initialize);
  document.addEventListener('cc:product-ready',event=>initialize(event.target));
})();
